import React, { Component } from 'react';
import { Form, Button, Col, Container,Row } from 'react-bootstrap';
import { sportEndPoint } from "../../constant/Environment";

class LiveBetSearch extends Component{
    constructor(props) {
        super(props);
        console.log(props);
      }
      state = {
        name: "",
        platform:"1",
        status:"",
        regdate: "",
        state: "",
        city: "",
        accounNumber:""
      };
    exportCsv = (e) => {
        e.preventDefault();
        var body = {
            type: "csv",
            status:this.props.report,
            period: "1m"
        }
        fetch(`${this.props.reporturl}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = this.props.report+'BetsReport.csv';
                        link.click();
                    })
                   
                });
    };
    exportPdf = (e) => {
        e.preventDefault();
        var body = {
            type: "pdf",
            status:this.props.report,
            period: "1m"
        }
        fetch(`${this.props.reporturl}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download =  this.props.report+'BetsReport.pdf';
                        link.click();
                    })
                });
    };
    render() {
       
        return( <Container fluid>
                    <Form>
                                       
                        <Row>
                        <Col>
                            <Form.Group as={Col} controlId="formPlayer">
                                <Form.Label className="label">Player</Form.Label>
                                <Form.Select                    
                                name="formPlayer"
                                required                           
                                >
                                    <option>Select Player</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                     
                            <Col>
                            <Form.Group as={Col} controlId="formLeage">
                                <Form.Label className="label">Tournament</Form.Label>
                                <Form.Select                    
                                name="formleage"
                                required                           
                                >
                                    <option>Select Tournament</option>
                        <option value="1">MLB</option>
                        <option value="2">NBA</option>
                        <option value="3">AFL</option>
                        <option value="4">NHL</option>
                        <option value="5">WNBA</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="formSport">
                                <Form.Label className="label">Sport</Form.Label>
                                <Form.Select                    
                                name="formSport"
                                required                           
                                >
                                    <option>Select Sport</option>
                        <option value="1">Baseball</option>
                        <option value="2">Ice Hockey</option>
                        <option value="3">Australian Rules</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="formMarket">
                                <Form.Label className="label">Market</Form.Label>
                                <Form.Select                    
                                name="formMarket"
                                required                           
                                >
                                    <option>Select Market</option>
                        <option value="1">Spread</option>
                        <option value="2">Money Line</option>
                        <option value="3">Total</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            {/* <Col></Col>  */}
                        </Row>
                        <Row>
                        
                        
                 
   <Col>
   <Button className='exportbtn' onClick={this.exportPdf}>
   <img src="/images/icons/pdf.png" />
   </Button>
   <Button className='exportbtn' onClick={this.exportCsv}>
   <img src="/images/icons/csv.png" />
   </Button>
   </Col>
   <Col>
                        <Button variant="primary" onClick={this.saveAndContinue}>Search</Button>
                        
                           </Col>
                           <Col></Col>
                           <Col></Col>
                        </Row>
                    </Form>
                </Container>
        );
    }
}

export default LiveBetSearch;